<form #formEmailCheck="ngForm" id="enterEmail" name="formEmailCheck" novalidate *ngIf="appCopy&& appCopy.panelHeader && copyLoaded">
  <h3 class="page__heading text-dark-blue margin-bottom-24">
    {{ appCopy.panelHeader["title" + selectedLanguage] }}
  </h3>

  <div class="panel">
    <div class="panel__header">{{ appCopy.panelHeader["description" + selectedLanguage] }}</div>
    <div class="panel__body">
      <div class="section">
        <p class="text-muted text-dark-blue">
          {{ appCopy.panelHeader["heading" + selectedLanguage] }}
        </p>
      </div>
      <div class="section section__colored">
        <div class="form-group">
          <input class="form-control" [ngClass]="{ 'has-error': email.invalid && email.dirty }" id="email" name="email"
            type="email" #email="ngModel" [(ngModel)]="userEmail" [pattern]="emailPattern" [placeholder]="appCopy.panelHeader['emailPlaceholder' + selectedLanguage]"
            ngModel required readonly />
          <p class="help-block text-danger" *ngIf="email?.errors?.pattern">
            {{ appCopy.panelHeader["validEmail" + selectedLanguage] }}
          </p>
          <p class="help-block text-danger" *ngIf="email.invalid && email.dirty && !email?.errors?.pattern">
            {{ appCopy.panelHeader["warningEmail" + selectedLanguage] }}
          </p>
        </div>
      </div>
      <div class="section section__actions flex flex--justify-content-center text-center">
        <button *ngIf="showPasswordOption" (click)="goToPassword($event)" class="btn btn-purple btn-lg"
          [disabled]="formEmailCheck.invalid">
          {{ appCopy.panelHeader["loginWithPasswordButton" + selectedLanguage] }}
        </button>

        <div *ngIf="showPasswordOption" class="hr-text text-center text-muted margin-top-24 margin-bottom-24 width-100">
          <span>{{ appCopy.panelHeader["orText" + selectedLanguage] }}</span>
        </div>

        <p class="text-muted text-dark-blue margin-bottom-24">
          {{ appCopy.panelHeader["loginWithOTPCodeText" + selectedLanguage] }}
        </p>

        <button (click)="sendOTP($event)" class="btn btn-purple btn-lg" [disabled]="formEmailCheck.invalid">
          <div class="loader-container-btn" *ngIf="showLoader">
            <div class="loader loader--white">
              <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div>
          {{ appCopy.panelHeader["sendOTPButton" + selectedLanguage] }}
        </button>
      </div>
    </div>
  </div>
</form>
